/**
 * Demo quotas to refetch after a merge: it binds the guest session to the
 * user, so a demo screen that showed "3 rounds left" goes unlimited. Only
 * the active queries refetch.
 */
export const DEMO_QUOTA_QUERIES = [
  'getDemoUpDownAiQuota',
  'getDemoBullseyeQuota',
  'getDemoUpDownQuota'
]
